export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    'big_win': [
      0,
      6593.015873015873,
    ],
    'button_spin': [
      8000,
      915.7369614512465,
    ],
    'end_free_spin': [
      10000,
      5214.331065759638,
    ],
    'end_free_spin_loop': [
      17000,
      12077.278911564626,
    ],
    'expanding_wild': [
      31000,
      3527.9818594104313,
    ],
    'free_bet_big_win': [
      36000,
      1377.2335600907013,
    ],
    'free_bet_mega_win': [
      39000,
      2213.151927437643,
    ],
    'free_bet_total_win': [
      43000,
      979.5918367346915,
    ],
    'free_bet_ultra_win': [
      45000,
      1319.1836734693893,
    ],
    'free_spin_ambient': [
      48000,
      68868.93424036283,
    ],
    'free_spin_music': [
      118000,
      57163.17460317461,
    ],
    'free_spin_start': [
      177000,
      8764.081632653073,
    ],
    'inside_buttons': [
      187000,
      407.8004535147386,
    ],
    'main_ambient': [
      189000,
      65966.43990929704,
    ],
    'main_music': [
      256000,
      162030.29478458053,
    ],
    'mega_win': [
      420000,
      5693.242630385498,
    ],
    'outside_buttons': [
      427000,
      393.28798185943015,
    ],
    'reel_spin': [
      429000,
      2776.2358276643795,
    ],
    'reel_stop_01': [
      433000,
      259.7732426303878,
    ],
    'reel_stop_02': [
      435000,
      280.0907029478594,
    ],
    'reel_stop_03': [
      437000,
      253.96825396825307,
    ],
    'reel_stop_04': [
      439000,
      256.87074829932044,
    ],
    'reel_stop_05': [
      441000,
      210.43083900224246,
    ],
    'regular_win': [
      443000,
      790.9297052154329,
    ],
    'scatter_stop': [
      445000,
      1118.9115646258756,
    ],
    'start-fs': [
      448000,
      3879.183673469413,
    ],
    'sticky_wild': [
      453000,
      2079.6371882086078,
    ],
    'tap_to_play': [
      457000,
      7777.233560090679,
    ],
    'train_going': [
      466000,
      3908.20861678003,
    ],
    'train_loop': [
      471000,
      3024.399092970498,
    ],
    'ultra_win': [
      476000,
      5899.319727891168,
    ],
    'wall_fall': [
      483000,
      2160.9070294784374,
    ],
  },
}
